import styles from "./title.module.scss";

type TProps = {
  text: string;
};

export default function Title({ text }: TProps) {
  return <div className={styles.title}>{text}</div>;
}
